import { Typography, Button, Box, CircularProgress } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import AppDialog from "./AppDialog";
// import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirmar acción",
  description = "¿Estás seguro de continuar?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  confirmColor = "primary",
  loading = false,
  fullScreenMobile = false,
  fullScreenBreakpoint = "sm",
}) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="xs"
      fullScreenMobile={fullScreenMobile}
      fullScreenBreakpoint={fullScreenBreakpoint}
      paperSx={{
        maxWidth: 460,
      }}
      actions={
        <>
          <Button
            onClick={onClose}
            color="inherit"
            disabled={loading}
            sx={{
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 800,
              px: 2.2,
            }}
          >
            {cancelText}
          </Button>

          <Button
            onClick={onConfirm}
            variant="contained"
            color={confirmColor}
            disabled={loading}
            sx={{
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 900,
              px: 2.6,
              minWidth: 130,
              boxShadow: "none",
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} color="inherit" />
                Procesando...
              </Box>
            ) : (
              confirmText
            )}
          </Button>
        </>
      }
    >
      <Box
        sx={{
          display: "flex",
          gap: 1.4,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 3,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(245, 31, 11, 0.12)",
            color: "#d91b06",
            border: "1px solid rgba(245, 15, 11, 0.22)",
            flexShrink: 0,
            mt: 0.2,
            "& svg": {
              fontSize: 22,
            },
          }}
        >
          <WarningAmberRoundedIcon />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 850,
              lineHeight: 1.5,
              color: "text.primary",
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </AppDialog>
  );
}
